<template>
  <div :class="$route.name !== 'login' && $route.name !== 'register' && $route.name !== 'verification' && $route.name !== 'reset-password' ? 'background-footer-bottom' : ''">
    <v-container v-if="$route.name !== 'login' && $route.name !== 'register' && $route.name !== 'verification' && $route.name !== 'reset-password'">
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <router-link to="/">
            <v-img 
              class="mx-auto"
              contain 
              width="150"
              height="auto"
              :src="require('../assets/logo/logo.png')">
            </v-img>
          </router-link>
        </v-col>
      </v-row>
      <v-row justify="center" class="pa-3">
        <v-col cols="12" sm="2">
          <p class="body-1 color-default font-weight-bold mb-5">
            Anak Cendekia.co.id
          </p>
          <router-link to="/aboutus" class="link">
            <p class="body-2 text-second mb-2">
              Tentang Kami
            </p>
          </router-link>
          <router-link to="/help" class="link">
            <p class="body-2 text-second mb-2">
              Bantuan
            </p>
          </router-link>
          <router-link to="/faq" class="link">
            <p class="body-2 text-second mb-2">
              FAQ
            </p>
          </router-link>
        </v-col>
        <v-col cols="12" sm="2">
          <p class="body-1 color-default font-weight-bold mb-5">
            Kebijakan
          </p>
          <router-link to="/privacy" class="link">
            <p class="body-2 text-second mb-2">
              Kebijakan Privasi
            </p>
          </router-link>
          <!-- <router-link to="/terms-conditions" class="link">
            <p class="body-2 text-second mb-2">
              Syarat & Ketentuan
            </p>
          </router-link> -->
        </v-col>
        <v-col cols="12" sm="3">
          <p class="body-1 color-default font-weight-bold mb-5">
            Kontak Kami
          </p>
          <router-link to="/" class="link">
            <p class="body-2 text-second mb-2">
              Telp: {{ content.contact.phoneNumber}}
            </p>
            <p class="body-2 text-second mb-2">
              Email: {{ content.contact.email }}
            </p>
          </router-link>
        </v-col>
        <v-col cols="12" sm="4">
          <p class="body-1 color-default font-weight-bold mb-5">
            Berlangganan
          </p>
          <v-row>
            <v-col cols="11" class="pt-0 pb-0 pr-0">
              <v-text-field
                dense
                rounded
                prepend-inner-icon="mdi-email-outline"
                placeholder="Email"
                color="#FF618A"
                single-line 
                hide-details="auto"
                filled
                style="background: #fffffffc;">
              </v-text-field>
            </v-col>
            <v-col cols="1" class="pt-0 pb-0 pl-0">
              <v-btn
                fab
                style="position: relative; top: 5px; right: 35px; height: 30px; width: 30px"
                elevation="0"
                color="#FF618A">
                <v-icon small color="white">mdi-near-me</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-avatar 
            v-for="(item, index) in sosmed"
            :key="index"
            tile
            class="mt-5"
            width="30"
            height="30">
            <a :href="`${item.sosmedUrl}`" target="_blank">
              <v-img
                class="cursor-pointer"
                contain
                width="30"
                height="30"
                :src="item.sosmedIcon">
              </v-img>
            </a>
          </v-avatar>
        </v-col>
      </v-row>
    </v-container>
    <div class="caption white--text background-default">
      <v-container class="py-0">
        <v-row class="px-12">
          <v-col cols="6">
            <div class="text-left">
              Copyright@{{ new Date().getFullYear() }} <strong>esd.co.id</strong>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="text-right">
              Powered by Era Solusi Data
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        // sosmed: ['facebook', 'instagram','twitter']
      }
    },
    computed: {
      sosmed () {
        let data = localStorage.getItem('sosmed')
        return !data ? this.$store.state.content.sosmed : JSON.parse(data)
      },
      content () {
        let data = localStorage.getItem('content')
        return !data ? this.$store.state.content.content : JSON.parse(data)
      }
    },
    mounted () {
      // if (!localStorage.getItem('sosmed')) {
        this.fetchSosmed()
      // }
    },
    methods: { 
      async fetchSosmed() {
        await this.$store.dispatch('content/getSosmed')
        .then((response) => {
          if (response.code === 200) {
            // set local storage
            localStorage.setItem('sosmed', JSON.stringify(response.data))
          }
        })
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
    }
  }
</script>

<style>
  
</style>
